export class RestoreGoogleWorkspaceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
